import { xray } from 'lib/xray';
import { overquotaThresholdLabel } from 'reactApp/appHelpers/featuresHelpers/features/overquotaStates';
import { getAccountDwhChains } from 'reactApp/modules/dwh/dwh.helpers';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';
import type { QuotaStates } from 'server/types/context/IUser';

export const sendOverquotaInfo = ({
    overquotaResolve,
    overquotaStatus,
    stopProcessing,
    threshold,
}: {
    overquotaResolve: boolean;
    overquotaStatus: QuotaStates | 'failedapi' | undefined;
    stopProcessing: boolean;
    threshold?: number;
}) => {
    const { dwhData: accountDwhData, dwhChains: accountDwhChains } = getAccountDwhChains();

    const platform = getPlatformInfo().join('_');

    const dwhData = {
        status: overquotaStatus || 'none',
        resolve: overquotaResolve,
        stop: stopProcessing,
        thl: overquotaThresholdLabel,
        threshold: threshold || 'none',
        platform,
        ...accountDwhData,
    };

    const baseDwhChains: (keyof typeof dwhData)[][] = [['used', 'status', 'resolve', 'stop', 'platform']];
    const treshholdChain: (keyof typeof dwhData)[] = ['used', 'status', 'threshold', 'thl', 'platform'];
    const dwh_enabled_fields = [...baseDwhChains, ...(overquotaThresholdLabel ? [treshholdChain] : []), ...accountDwhChains];

    xray.send('overquota-info', {
        dwh_enabled: true,
        dwh_enabled_fields,
        dwh: dwhData,
    });
};
